<template>
  <div class="flex-1 pt-12 pb-24 flex flex-col">
    <BaseLoader v-if="loading.menu" />
    <q-card
      v-else-if="arquivo?.arquivo"
      class="flex-1 h-full shadow-lg border border-neutral-100/10 flex flex-col p-24"
    >
      <iframe
        v-if="isPdf"
        :src="arquivo?.arquivo"
        v-bind="iframeProps"
        class="size-full flex-1 rounded-md"
      />
      <img
        v-else
        :src="arquivo?.arquivo"
        class="size-full object-contain m-auto rounded-md aspect-video"
      >
    </q-card>
    <EmptyItem v-else />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import EmptyItem from 'components/Empty/EmptyItem.vue'
import useMenu from 'composables/useMenu'

const route = useRoute()

const { loading, menu } = useMenu()

const iframeProps = ref({
  frameborder: 0,
  allow: 'fullscreen',
})
const arquivo = computed(() => {
  return menu.value.botao_menu_lateral.find(
    (item) => item.id === +route.params.id
  )
})

const isPdf = computed(() => arquivo.value?.arquivo?.endsWith('.pdf'))
</script>

<style lang="scss" scoped></style>
